// On document ready
document.addEventListener('DOMContentLoaded', () => {

  // Get all embla nodes
  const emblaNodes = Array.from(document.querySelectorAll('.embla-carousel')).filter(node => {
    const slides = node.querySelectorAll('.embla__slide');
    return slides.length > 1;
  });
  const options = {
    loop: false,
    slidesToScroll: 1,
    active: true,
    containScroll: 'trimSnaps',

    // // 900px breakpoint, scroll 4 slides
    // 'min-width: 992px': {
    //   slidesToScroll: 3,
    //   active: false,
    // },
  }

  // Loop through all embla nodes
  emblaNodes.forEach(emblaNode => {
    // Initialize EmblaCarousel
    const emblaApi = EmblaCarousel(emblaNode, options, [EmblaCarouselClassNames()])
    const snapDisplayNode = emblaNode.querySelector('.embla__selected-snap-display')

    // Grab button nodes
    const prevButtonNodes = emblaNode.querySelectorAll('.embla__prev')
    const nextButtonNodes = emblaNode.querySelectorAll('.embla__next')

    // Add click listeners
    prevButtonNodes.forEach(prevButtonNode => {
      prevButtonNode.addEventListener('click', () => emblaApi.scrollPrev(), false)
    })
    nextButtonNodes.forEach(nextButtonNode => {
      nextButtonNode.addEventListener('click', () => emblaApi.scrollNext(), false)
    })

    if(snapDisplayNode !== null) {
      const updateSnapDisplay = (emblaApi) => {
        const selectedSnap = emblaApi.selectedScrollSnap()
        const snapCount = emblaApi.scrollSnapList().length
        snapDisplayNode.innerHTML = `${selectedSnap + 1} of ${snapCount}`
      }

      emblaApi.on('select', updateSnapDisplay).on('reInit', updateSnapDisplay)

      updateSnapDisplay(emblaApi)
    }

    // If the last slide is in view, disable the next button
    emblaApi.on('scroll', () => {

      if(!emblaNode.querySelector(".embla__slide:last-child").classList.contains("is-in-view")) {
        nextButtonNodes.forEach(nextButtonNode => {
          nextButtonNode.removeAttribute('disabled')
        })
      } else {
        nextButtonNodes.forEach(nextButtonNode => {
          nextButtonNode.setAttribute('disabled', 'disabled')
        })
      }

      if(emblaApi.canScrollPrev()) {
        prevButtonNodes.forEach(prevButtonNode => {
          prevButtonNode.removeAttribute('disabled')
        })
      } else {
        prevButtonNodes.forEach(prevButtonNode => {
          prevButtonNode.setAttribute('disabled', 'disabled')
        })
      }
    })

  })

})
